import './style';
import './mobile';
import App from './components/app';

import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloProvider } from 'react-apollo';

const httpLink = createHttpLink({ uri: 'https://kidsuper.wholesali.ng/api/graphql' })

const middlewareLink = setContext(() => ({
  headers: {
 'X-Shopify-Storefront-Access-Token': '540db4a26dfdb761f5e0fef2760e6b0b'
  }
}))

const client = new ApolloClient({
  link: middlewareLink.concat(httpLink),
  cache: new InMemoryCache(),
})

export default () => (
  <ApolloProvider client={client}>
    <App client={client} />
  </ApolloProvider>
)


// This removes a service worker that may have been installed by mistake during
// previous deployments.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(function(registration) {
    registration.unregister()
  })
}

// - fetch something on collections


// later
// 5) chat global

// need to combine with chat
// pusher.com was very easy to get going. But what I need is a chat that acts globally that you can sign in

// With email and you make a username
// Then this email and username can be used later for the custom aspects of the site


// done
// 1) i need to add route to product so I can show all pictures desc and stuff
// 2) the graph call is kinda slow when u do all 50 items so some sort of lazy load is needed - 10 
// always download all (is it a problem? don't think so) 
// 4) cart global - done or almost
// dynamic
// /products/product-slug
// need: ok being hardcoded
// /collections/tops
// /collections/bottoms
// /collections/accessories 
// download 1 if opened directly and not fetched yet
// 3) also when on the product page — and you scroll down the next product loads in like blog articles



// WEBPACK FOOTER //
// ./index.js